/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const HeroiconsMiniMoon = ({ className }) => {
  return (
    <svg
      className={`heroicons-mini-moon ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        clipRule="evenodd"
        d="M7.45519 2.00399C7.68518 2.18769 7.78646 2.48895 7.71414 2.77428C7.57443 3.32551 7.5 3.90353 7.5 4.5C7.5 8.366 10.634 11.5 14.5 11.5C15.6435 11.5 16.721 11.2264 17.6724 10.7417C17.9347 10.6081 18.2509 10.6403 18.4809 10.824C18.7109 11.0077 18.8122 11.3089 18.7399 11.5943C17.8069 15.2755 14.4725 18 10.5 18C5.80558 18 2 14.1944 2 9.5C2 6.19143 3.89048 3.32572 6.64671 1.92173C6.909 1.78812 7.22519 1.8203 7.45519 2.00399Z"
        fill="#7041F1"
        fillRule="evenodd"
      />
    </svg>
  );
};
